module.exports = __webpack_public_path__ + "img/pro.75dcd182.png";